<template>
  <v-row>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.people"
        :error-messages="error.people"
        :model="showPersonModel"
        :extra-params="modelFk"
        item-text="person__name"
        item-value="id"
        label="Musicisti"
        multiple
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.guests_total"
        :error-messages="error.guests_total"
        label="Totale ospiti"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.start_date"
        :error-messages="error.start_date"
        label="Inizio"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.end_date"
        :error-messages="error.end_date"
        label="Fine"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.room"
        :error-messages="error.room"
        :model="showRoomModel"
        :extra-params="modelFk"
        item-text="room__name"
        item-value="id"
        label="Stanza"
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-text-field
        v-model="editedItem.cost"
        :error-messages="error.cost"
        label="Costo totale"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.kind"
        :error-messages="error.kind"
        label="Tipo di prenotazione"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <v-select
        v-model="editedItem.status"
        :error-messages="error.status"
        :items="[
          { value: 1, text: 'bloccata' },
          { value: 2, text: 'confermata' },
          { value: 3, text: 'pagata' },
        ]"
        :readonly="!profile.is_staff"
        label="Stato"
      ></v-select>
    </v-col>
    <v-col v-if="profile.is_staff" cols="12" sm="4">
      <v-textarea
        v-model="editedItem.notes"
        :error-messages="error.notes"
        :readonly="!profile.is_staff"
        label="Note"
      ></v-textarea>
    </v-col>

    <v-col
      v-if="
        profile.is_staff &&
        editedItem.warnings &&
        editedItem.warnings.length > 0
      "
      cols="12"
      sm="4"
    >
      <ul>
        <li
          v-for="(warning, index) in editedItem.warnings"
          :key="index"
          class="red--text"
        >
          <template v-if="warning.type == 'room_booking_overlap'">
            Sovrapposizione prenotazioni per la stessa camera
          </template>
          <template v-else-if="warning.type == 'room_capacity_exceeded'">
            Numero ospiti ({{ warning.guests_total }}) supera capacità della camera ({{ warning.room_capacity }})
          </template>
          <template v-else-if="warning.type == 'booking_outside_room_availability_range'">
            Prenotazione fuori dal range di disponibilità della camera
          </template>
          <template v-else-if="warning.type == 'booking_outside_person_availability_range'">
            Prenotazione fuori dal range di disponibilità della persona {{ warning.person }}
          </template>
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
import models from "@/models"

export default {
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    modelFk: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPersonModel: models.ShowPerson,
      showRoomModel: models.ShowRoom,
    }
  },
}
</script>
